var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItinerarywhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.75L10 21.25L15.625 15.625M10 10V6.5C10 5.09987 10 4.3998 10.2725 3.86503C10.5122 3.39461 10.8946 3.01216 11.365 2.77249C11.8998 2.5 12.5999 2.5 14 2.5H23.5C24.9001 2.5 25.6003 2.5 26.135 2.77249C26.6054 3.01216 26.9879 3.39461 27.2275 3.86503C27.5 4.3998 27.5 5.09987 27.5 6.5V16C27.5 17.4001 27.5 18.1002 27.2275 18.635C26.9879 19.1054 26.6054 19.4879 26.135 19.7275C25.6003 20 24.9001 20 23.5 20H20M6.5 27.5H16C17.4001 27.5 18.1002 27.5 18.635 27.2275C19.1054 26.9879 19.4879 26.6054 19.7275 26.135C20 25.6003 20 24.9001 20 23.5V14C20 12.5999 20 11.8998 19.7275 11.365C19.4879 10.8946 19.1054 10.5122 18.635 10.2725C18.1002 10 17.4001 10 16 10H6.5C5.09987 10 4.3998 10 3.86503 10.2725C3.39461 10.5122 3.01216 10.8946 2.77249 11.365C2.5 11.8998 2.5 12.5999 2.5 14V23.5C2.5 24.9001 2.5 25.6003 2.77249 26.135C3.01216 26.6054 3.39461 26.9879 3.86503 27.2275C4.3998 27.5 5.09986 27.5 6.5 27.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItinerarywhiteIcon);
export default __webpack_public_path__ + "static/media/Itinerarywhite-icon.4da62dbc8eab042afe6350a9cdf1d965.svg";
export { ForwardRef as ReactComponent };